/**
 * @generated SignedSource<<719d14ec29b6fa1f2d63e496ec521ed8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type fileElementForm_FileElementV2Fragment$data = {
  readonly file: {
    readonly id: string;
    readonly name: string;
    readonly url: string | null;
  } | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "fileElementForm_FileElementV2Fragment";
};
export type fileElementForm_FileElementV2Fragment$key = {
  readonly " $data"?: fileElementForm_FileElementV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"fileElementForm_FileElementV2Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "fileElementForm_FileElementV2Fragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FileElementV2",
  "abstractKey": null
};
})();

(node as any).hash = "4cb88a5af38e35c5a5d88d9fd8279d55";

export default node;
